import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { IUseKebijakanPrivasi } from "./user-kebijakan-privasi.types";

const useKebijakanPrivasi = (): IUseKebijakanPrivasi => {
  const [language, setLanguage] = useState<"en" | "id">("id");
  const router = useRouter();
  const { lang } = router.query;

  useEffect(() => {
    if (lang === "en") setLanguage("en");
    else setLanguage("id");
  }, [lang]);

  return { language };
};

export { useKebijakanPrivasi };
